import Button from '~/components/Button';
import { Input } from '~/components/form';
import inputStyles from '~/components/form/Input.module.css';
import {
  Form,
  Link,
  useActionData,
  type LinksFunction,
  type V2_MetaFunction,
} from '~/remix';
import { getErrors } from '~/utils/data';
import routeStyles from './_route.module.css';
import { action, loader } from './_route.server';
export { action, loader };

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Register' },
];

export let links: LinksFunction = () => [
  { rel: 'stylesheet', href: inputStyles },
  { rel: 'stylesheet', href: routeStyles },
];

export default function () {
  const data = useActionData<typeof action>();
  const errors = getErrors(data);
  return (
    <div>
      <div className="flex justify-center">
        <Form replace method="post" className="space-y-6">
          <div className="flex w-[400px] flex-col items-center p-6">
            <div className="mb-8 w-full bg-white p-6">
              <div className="text-center">
                <h2 className="text-2xl font-extrabold text-accent-medium">
                  Register new account
                </h2>
              </div>
              <div>
                <p className="login-redirect-text">
                  Already have an account? Login{' '}
                  <Link to="/login" className="underline">
                    here
                  </Link>
                </p>
              </div>
              <div className="mt-8 flex flex-col gap-4">
                <div>
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      autoComplete="given-name"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-accent-light focus:outline-none focus:ring-accent-light sm:text-sm"
                    />
                    {errors.firstName && (
                      <div className="mt-2 text-sm text-red-600">
                        {errors.firstName}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="lastName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      autoComplete="family-name"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-accent-light focus:outline-none focus:ring-accent-light sm:text-sm"
                    />
                    {errors.lastName && (
                      <div className="mt-2 text-sm text-red-600">
                        {errors.lastName}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="phoneNumber"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      id="phoneNumber"
                      name="phoneNumber"
                      type="text"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-accent-light focus:outline-none focus:ring-accent-light sm:text-sm"
                    />
                    {errors.phoneNumber && (
                      <div className="mt-2 text-sm text-red-600">
                        {errors.phoneNumber}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email address <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      pattern="[^@\s]+@[^@\s]+(\.[^@\s]+)+"
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-accent-light focus:outline-none focus:ring-accent-light sm:text-sm"
                    />
                    {errors.email && (
                      <div className="mt-2 text-sm text-red-600">
                        {errors.email}
                      </div>
                    )}
                  </div>
                </div>

                <div className="space-y-1">
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    label="Password"
                    required
                    error={errors.password}
                  />
                </div>
                <div className="space-y-1">
                  <Input
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    autoComplete="new-password"
                    required
                    error={errors.confirmPassword}
                  />{' '}
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="acceptTerms"
                      name="acceptTerms"
                      type="checkbox"
                      required
                      className="h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                    />
                    <label
                      htmlFor="acceptTerms"
                      className="ml-2 block text-sm text-gray-900"
                    >
                      I accept the{' '}
                      <Link
                        to="/terms?register=true"
                        className="font-medium text-accent-medium underline hover:text-accent-light"
                      >
                        Terms of Service
                      </Link>{' '}
                      <span className="text-red-500">*</span>
                    </label>
                    {errors.acceptTerms && (
                      <div className="mt-2 text-sm text-red-600">
                        {errors.acceptTerms}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <span className="text-sm text-red-500">* Required</span>
              </div>
            </div>
            <div>
              <Button type="submit" size="lg" variant="primary">
                Register
              </Button>
            </div>
            {errors.form && (
              <div className="mt-2 text-sm text-red-600">{errors.form}</div>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
}
